// @flow

import type { ShiftPatternsState } from "./types";
import { UnassignReassignShiftPatternTypeEnum } from "@modules/service/constants";

export const initialState: ShiftPatternsState = {
  requestsInProgress: 0,
  error: null,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  totalList: [],
  current: null,
  draft: null,
  employeePositionsAssignedToShiftPattern: null,
  departmentsAssignedToShiftPattern: null,
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDeleteModal: false,
    reassignItemsToShiftPatternModal: {
      visible: false,
    },
    unassignReassignShiftPatternModal: {
      visible: false,
      shiftPattern: null,
      type: UnassignReassignShiftPatternTypeEnum.EMPLOYEES,
    },
  },
};

export default initialState;
